import React from "react";
import { Navigate } from "react-router";
import { NavLink } from "react-router-dom";
import Base from "../Base";
import { Header } from "../Header";
import { Footer } from "../Footer";
import Andikator from "./Andikator";

export default class Persons extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: "andikator",
            data: null,
            loading: true,
            moduleName: "",
            filters: {
                title: "",
                type: 0,
            },
            page: 1,
            per_page: 30,
            phrase: '',
            systemModuleId: 27,
            moduleAccessStatus: 1,
            menuId: 30
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Andikator Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Andikator Caller={this} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست اندیکاتورها</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} اندیکاتر یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><span className="shortcut">F2 - </span><span>ایجاد اندیکاتور جدید</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap me-1">
                                                <input
                                                    type="text"
                                                    defaultValue={this.state.filters.title}
                                                    onChange={(e) => (this.state.filters.title = e.target.value)}
                                                    placeholder="عنوان اندیکاتور"
                                                    className="form-control with-300"
                                                />
                                            </div>
                                            <div className="form-wrap me-1">
                                                <select
                                                    defaultValue={this.state.filters.type}
                                                    onChange={e => this.state.filters.type = parseInt(e.target.value)}
                                                    className="form-control text-center">
                                                    <option value='0'>همه نوع نامه ها</option>
                                                    <option value="1">نامه داخلی</option>
                                                    <option value="2">نامه صادره</option>
                                                    <option value="3">نامه داخلی</option>
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ اندیکاتوری یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">عنوان</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شروع شماره گذاری</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">پسوند شماره گذاری</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">پیشوند شماره گذاری</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نوع نامه</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">پیش فرض</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ ثبت</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.title}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.startNumber}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.postfix}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.prefix}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.typeString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.statusString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.isDefault ? "بله" : "خیر"}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.addDateString}</span>
                                                </div>
                                                <div className="nk-tb-col text-end">
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        <em className="icon ni ni-cross-fill-c"></em>
                                                    </a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                        <em className="icon ni ni-pen"></em>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">{this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}</div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}